export enum SessionStorageKeys {
  UNAVAILABLE_AIRPLANE_DELIVERY = 'UnavailableAirplaneDelivery',
  DAP_PAGE_DATA = 'DapPageData',
  DAP_RESET_PAYMENT = 'DapResetPayment',
}
